/**
 * Constants related to promotions.
 */
const PROMOTIONS = {
  /**
   * Date / time format required for querying promotions.
   *
   * @property DATE_FORMAT
   * @type {String}
   */
  DATE_FORMAT: 'YYYY-MM-DD[T]HH:mm:ss',
}

const PROMO_CODE_STATUES = {
  APPLIED: 'applied',
  EXPIRED: 'expired',
  INCORRECT_OUTLET: 'incorrect_outlet',
  INSUFFICIENT_BUY: 'insufficient_buy',
  INSUFFICIENT_SPEND: 'insufficient_spend',
  INSUFFICIENT_GET: 'insufficient_get',
  INVALID: 'invalid',
  OTHER: 'other',
  REDEEMED: 'redeemed',
  REDEEMED_MULTI: 'redeemed_multi',
  UPCOMING: 'upcoming',
}

/**
 * @deprecated These are now in `PromoCodeError.tsx` and translated.
 */
const PROMO_CODE_STATUES_ERROR_MSGS = {
  [PROMO_CODE_STATUES.EXPIRED]: 'Code can no longer be redeemed.',
  [PROMO_CODE_STATUES.INCORRECT_OUTLET]:
    'The code cannot be redeemed at this outlet.',
  [PROMO_CODE_STATUES.INSUFFICIENT_BUY]:
    'This code cannot be redeemed as the buy condition has not been met.',
  [PROMO_CODE_STATUES.INSUFFICIENT_SPEND]:
    'This code cannot be redeemed as the spend condition has not been met.',
  [PROMO_CODE_STATUES.INSUFFICIENT_GET]:
    'This code cannot be redeemed as the get condition has not been met.',
  [PROMO_CODE_STATUES.INVALID]: 'Invalid code entered.',
  [PROMO_CODE_STATUES.OTHER]:
    'This code cannot be redeemed as it conflicts with promotions/discounts already applied to products in the sale.',
  [PROMO_CODE_STATUES.REDEEMED]: 'The code has already been redeemed.',
  [PROMO_CODE_STATUES.REDEEMED_MULTI]: 'This code has run out of redemptions.',
  [PROMO_CODE_STATUES.UPCOMING]: "This promo code can't be redeemed just yet.",
  default:
    "This code couldn't be validated. Please refresh the page and try again.",
}

const PROMOTIONS_ENDPOINT = '/api/2.0/promotions'

export {
  PROMOTIONS,
  PROMO_CODE_STATUES,
  PROMO_CODE_STATUES_ERROR_MSGS,
  PROMOTIONS_ENDPOINT,
}
